import React, { useEffect, useState, useRef } from "react";
import {
  Layout,
  Row,
  Col,
  Avatar,
  Modal,
  Skeleton,
  Tooltip,
  Popover,
  Dropdown,
} from "antd";
import { Link } from "react-router-dom";
import logo from "../assets/InsytLogo.svg";
import userlogo from "../assets/InsytLogo.svg";
import {
  MenuUnfoldOutlined, MenuFoldOutlined, ClockCircleOutlined,
  PauseOutlined,
  CaretRightOutlined,
  StopOutlined,
} from "@ant-design/icons";
import OutlinedInput from "@mui/material/OutlinedInput";
import SettingsIcon from "@mui/icons-material/Settings";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import { Select as MUISelect, Chip, Box, createTheme } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { useMedia } from "react-use";
import { startCase, get } from "lodash";
import { connect, useSelector } from "react-redux";
import {
  getUserName,
  getSelectedDepartmentId,
  getDepartmentList,
  getRoleName,
  getDepartmentName,
  getLoadingDataFirstTime,
  getUserRoleId,
  getRoleList,
  getUserRoleList,
  getNotificationList,
  getUserInfo,
  getProfilePic,
  getAllDepartmentList,
  getClientid,
  getMenuList,
  getLeaveCategoryList,
  getHigherOfficials,
} from "redux/selectors";
import { bindActionCreators } from "redux";
import {
  setDepartmentId,
  setNotificationList,
  clearStore,
  toggleProcessingModal,
} from "redux/actions";
import styled from "@emotion/styled";
import COLORS from "common/Colors";

// Components
import CustomIcon from "atoms/Icon";
import SwitchUserModal from "organisms/SwitchUserModal";
import { DEVICE } from "common/Device";
import DashboardTop from "./DashboardTop";
import LeaveForm from "organisms/LeaveForm";
import TimeLog from "organisms/TimeLog";
import AddTask from "organisms/AddTask";
import ClaimsLogModal from "organisms/ClaimsLogModal";
import FundRequestModal from "organisms/FundRequestModal";
import CreateEventModal from "organisms/CreateEventModal";

import Subscription from "./Subscription";
import { Products } from "common/Constants";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import bdoLogo from "assets/bdo logo.svg";
import { CALL_API } from "common/API";
import moment from "moment";
import axios from "axios";
import FloatingButton from "reusableComponent/FloatingButton";
import { PlusOutlined } from "@ant-design/icons";
import ReportIncident from "pages/IncidentManagement/ReportIncident";

import {
  Modal as AntModal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
} from "antd";

const AntHeader = Layout.Header;

// ─── Styled Components ───────────────────────────────────────────────────────

const StyledCol = styled(Col)`
  text-align: right;
  display: flex;
  justify-content: end;
  @media ${DEVICE.mobileL} {
    margin-left: 0px;
  }
  @media ${DEVICE.mobileM} {
    margin-left: 0px;
    text-align: none;
  }
`;

const StyleSubmitButton = styled(ButtonFilled)`
  margin-right: 0.7rem;
  font-weight: 600;
  @media (min-width: 320px) and (max-width: 374px) {
    margin-top: 65px;
  }
  @media (min-width: 375px) and (max-width: 424px) {
    margin-top: 65px;
    padding: 3px;
    font-size: 12px !important;
  }
  @media (min-width: 425px) and (max-width: 550px) {
    margin-top: 65px;
  }
  @media (max-width: 325px) {
    padding: 3px;
    font-size: 12px !important;
  }
`;

const StyledIconContainer = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  white-space: pre;
`;

const StyledAntHeader = styled(AntHeader)`
  padding: 0px;
  box-shadow: 0px 2px 5px 0px #b1b1b1;
  background: #ffffff;
  z-index: 9;
  height: auto;
  .left-header-skeleton {
    margin: 10px;
  }
  .right-header-skeleton {
    margin: 10px;
  }
  .icon {
    color: black;
  }
  .ant-popover-inner {
    margin: 0 10px;
  }
  @media (max-width: 430px) {
    line-height: 24px !important;
  }
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 0.5rem;
  margin-bottom: 5px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
  color: #ffffff;
`;

const StyleSuperHODDiv = styled.div`
  padding-left: 5px;
  padding-top: 10px;
  .hide {
    display: inline;
  }
  .dept_info {
    min-width: 300px;
    max-width: 300px;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
      min-width: 200px;
      margin-top: 13px;
    }
  }
  span {
    line-height: 20px;
    display: block;
  }
  img {
    display: none;
  }
  @media ${DEVICE.tablet} {
    .hide {
      display: none;
    }
    span {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    img {
      display: inline;
    }
  }
  @media (max-width: 1250px) {
    span {
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  @media (max-width: 320px) {
    span {
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

const StyledButtonUpdate = styled(Button)`
  background: #00685f !important;
  border-radius: 5px;
  color: #ffffff !important;
  width: 100px;
  margin-bottom: 10px;
  &:hover {
    color: #ffffff !important;
  }
`;

const StyledButtonCancel = styled(Button)`
  background: #ffffff !important;
  border-radius: 5px;
  color: #000000 !important;
  width: 100px;
  border-color: #000000 !important;
  &:focus {
    color: #000000 !important;
  }
`;

const menuIconStyle = `font-size: 18px; line-height: 64px; padding: 0 24px; cursor: pointer; transition: color 0.3s;`;
const StyledMenuUnfoldOutlined = styled(MenuUnfoldOutlined)`
  ${menuIconStyle}
`;
const StyledMenuFoldOutlined = styled(MenuFoldOutlined)`
  ${menuIconStyle}
`;

const StyledMenuToggle = styled.div`
  display: none;
  @media ${DEVICE.tablet} {
    display: inline-flex;
    z-index: 100;
    position: relative;
    float: left;
    margin-left: 3px;
    padding: 10px;
    .anticon-menu-fold,
    .anticon-menu-unfold {
      padding: 2px 0px 0px 0px;
    }
  }
  ${({ collapsed }) => collapsed && `margin-left: -10px`}
`;

const TimerBadgeInline = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #6c6f7d;
  color: #fff;
  border-radius: 20px;
  height: 30px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;

const StyledMenuToggle1 = styled.div`
  display: inline;
  float: left;
  padding: 10px;
  .anticon-menu-fold,
  .anticon-menu-unfold {
    padding: 2px 0px 0px 0px;
  }
  ${({ collapsed }) => collapsed && `margin-left: -10px`}
  @media ${DEVICE.tablet} {
    display: none;
  }
`;

const StyledHeaderIcons = styled.div`
  display: inline-block;
  @media ${DEVICE.tablet} {
    margin-top: -30px;
    position: absolute;
    top: -54px;
    right: 0px;
  }
  .ant-popover-inner {
    margin: 0 10px !important;
  }
`;

// ─── Floating Timer Styles ────────────────────────────────────────────────────

const TimerIconBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #deefee;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;
  flex-shrink: 0;
  &:hover {
    background: #deefee;
    transform: scale(1.07);
  }
`;

const TimerIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#00685F">
    <path d="M15 1H9v2h6V1zm-3 4a9 9 0 100 18 9 9 0 000-18zm1 9H11V8h2v6z" />
  </svg>
);

const TimerGreyIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#00685F">
    <path d="M15 1H9v2h6V1zm-3 4a9 9 0 100 18 9 9 0 000-18zm1 9H11V8h2v6z" />
  </svg>
);

const TimerCtrlBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 6px;
  padding: 5px 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  background: transparent;
  &:hover {
    opacity: 0.85;
  }
`;

const NewButtonWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-right: 12px;
  .apply-leave-sm {
    color: #000000 !important;
    border-color: #000000 !important;
  }
`;

// ─── Timer States ─────────────────────────────────────────────────────────────
const T = { IDLE: "idle", RUNNING: "running", PAUSED: "paused" };

function formatTime(secs) {
  const m = String(Math.floor(secs / 60)).padStart(2, "0");
  const s = String(secs % 60).padStart(2, "0");
  return `${m}:${s}`;
}

// ─── Clock SVG Icon ───────────────────────────────────────────────────────────
const ClockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#00a870"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

// ─── NEW MENU ITEMS (keys only — handlers live in handleNewMenuSelect) ─────────
const NEW_MENU_ITEMS = [
  { key: "applyLeave", label: "Apply Leave" },
  { key: "timeLog", label: "Time Log" },
  { key: "claimsLog", label: "Claims Log" },
  { key: "matter", label: "Matter" },
  { key: "fundRequest", label: "Fund Request" },
  { key: "client", label: "Client" },
  { key: "task", label: "Task" },
  { key: "event", label: "Event" },
  { key: "report-incident", label: "Report Incident" },
];

// ─── Main Header ──────────────────────────────────────────────────────────────

const Header = ({
  setPageTitle,
  selectedDepartmentId,
  departmentName,
  updateDepartmentId,
  userName,
  collapsed,
  toggleCollapse,
  isLoadingDataFirstTime,
  userRoleId,
  roleList,
  showDrawer,
  userInfo,
  profilePic,
  allDepartmentList,
  clientId,
  setshowplan,
  showplan,
  isLoggedOut,
  removeStoreData,
  updateProcessingModal,
  startLogoutLoader,
  setLoggedIn,
  menuList,
  leaveCategoryList,
}) => {
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  const [userRoleModal, setUserRoleModal] = useState(false);
  const [deptFullList, setDeptFullList] = useState([]);
  const [displayLeaveModal, toggleLeaveModal] = useState(false);

  // ── New Button state ──
  const [showNewMenu, setShowNewMenu] = useState(false);
  const [displayTimeLogModal, toggleTimeLogModal] = useState(false);
  const [displayClaimsLogModal, toggleClaimsLogModal] = useState(false);
  const [displayFundRequestModal, toggleFundRequestModal] = useState(false);
  const [displayTaskModal, toggleTaskModal] = useState(false);
  const [displayEventModal, toggleEventModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // ✅ Fixed: moved inside component
  const [displayIncidentModal, toggleIncidentModal] = useState(false);

  const newMenuRef = useRef(null);

  // ── Header Timer State ──────────────────────────────────────────────────────
  const [timerState, setTimerState] = useState(T.IDLE);
  const [elapsed, setElapsed] = useState(0);
  const [timerElapsedHours, setTimerElapsedHours] = useState(null);
  const timerIntervalRef = useRef(null);

  useEffect(() => {
    clearInterval(timerIntervalRef.current);
    if (timerState === T.RUNNING) {
      timerIntervalRef.current = setInterval(
        () => setElapsed((prev) => prev + 1),
        1000
      );
    }
    return () => clearInterval(timerIntervalRef.current);
  }, [timerState]);

  // ── Timer handlers ──────────────────────────────────────────────────────────
  const handleTimerIconClick = () => {
    setElapsed(0);
    setTimerState(T.RUNNING);
  };

  const handleTimerPause = () => setTimerState(T.PAUSED);
  const handleTimerPlay = () => setTimerState(T.RUNNING);

  const handleTimerStop = () => {
    clearInterval(timerIntervalRef.current);
    const hours = (elapsed / 3600).toString();
    setTimerState(T.IDLE);
    setElapsed(0);
    setTimerElapsedHours(hours);
    toggleTimeLogModal(true);
  };

  const handleTimeLogClose = () => {
    toggleTimeLogModal(false);
    setTimerElapsedHours(null);
  };

  const handleGetTaskList = () => { };

  // ───────────────────────────────────────────────────────────────────────────

  const higherOfficialsList = useSelector((state) =>
    getHigherOfficials(state)
  );
  const higherOfficialsListReduce = higherOfficialsList?.reduce((acc, curr) => {
    acc.push(...(curr.useremails || []));
    return acc;
  }, []);

  let history = useHistory();

  const getPayAccessUsers = (userid) =>
    higherOfficialsListReduce?.includes(userid);
  const PayAccess = getPayAccessUsers(userInfo?.userid || "");

  const filterRoleList = roleList?.filter(
    (item) => item?.roleId === userRoleId
  );
  const filterDepartmentId = filterRoleList[0]?.department;
  const filterDepartment = allDepartmentList?.filter((item) =>
    filterDepartmentId?.includes(item?.department_id)
  );

  const handleNewMenuSelect = (key) => {
    setShowNewMenu(false);
    switch (key) {
      case "applyLeave":
        toggleLeaveModal(true);
        break;
      case "timeLog":
        setTimerElapsedHours(null);
        toggleTimeLogModal(true);
        break;
      case "claimsLog":
        toggleClaimsLogModal(true);
        break;
      case "fundRequest":
        toggleFundRequestModal(true);
        break;
      case "task":
        toggleTaskModal(true);
        break;
      case "event":
        toggleEventModal(true);
        break;
      case "client":
        history.push("/client-new");
        break;
      case "matter":
        history.push("/create-matter");
        break;
      case "report-incident":
        // ✅ Fixed: toggleIncidentModal now in scope
        toggleIncidentModal(true);
        break;
      default:
        break;
    }
  };

  const dropdownItems = NEW_MENU_ITEMS.map((item) => ({
    key: item.key,
    label: item.label,
    onClick: () => handleNewMenuSelect(item.key),
  }));

  const handleLogout = () => {
    startLogoutLoader(true);
    setTimeout(() => {
      window.localStorage.removeItem("token");
      isLoggedOut();
      removeStoreData();
      window.location.href = "https://www.insyts.ai";
    }, 500);
  };

  const logoutUser = () => {
    Modal.confirm({
      icon: "",
      content: "Are you sure you want to logout?",
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn
            style={{
              backgroundColor: "#ff4d4f",
              borderColor: "#ff4d4f",
              color: "#fff",
            }}
          />
        </>
      ),
      okText: "Logout",
      cancelText: "Cancel",
      onOk: () => {
        startLogoutLoader(true);
        setTimeout(() => {
          window.localStorage.removeItem("token");
          isLoggedOut();
          removeStoreData();
          window.location.href = "https://www.insyts.ai";
        }, 500);
      },
    });
  };

  useEffect(() => {
    intialFunction();
  }, [departmentName]);

  const intialFunction = async () => {
    const newArr = [];
    await filterDepartment?.forEach((element) => {
      selectedDepartmentId.forEach((e) => {
        if (element.department_id === e) newArr.push(element.department_name);
      });
    });
    setDeptFullList(newArr);
  };

  const getNotificationListFn = async () => {
    if (clientId) {
      /* fetch notifications */
    }
  };

  useEffect(() => {
    getNotificationListFn();
    const timer = setInterval(() => {
      getNotificationListFn();
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (newMenuRef.current && !newMenuRef.current.contains(e.target))
        setShowNewMenu(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const headerSkeleton = (classname) => (
    <Skeleton.Input className={classname} active={true} size="small" />
  );

  const ExtramediumDevice = useMedia("(min-width: 1200px)");
  const mediumDevice = useMedia("(min-width: 900px)");
  const imgStyle = { height: "35px", marginTop: "5px" };
  const customIconStyle = { height: "16px", cursor: "pointer" };
  const [showSwitchApp, setShowSwitchApp] = useState(false);

  return (
    <StyledAntHeader>
      <Row>
        <Col xs={24} sm={24} md={24} lg={6} xl={9} className="d-flex">
          {isLoadingDataFirstTime && headerSkeleton("left-header-skeleton")}
          {!isLoadingDataFirstTime && (
            <StyleSuperHODDiv>
              <Row>
                <Col>
                  <Row>
                    <Link to={`dashboard`} onClick={() => setPageTitle("")}>
                      <img style={imgStyle} src={bdoLogo} alt="Tymeplus" />
                    </Link>
                  </Row>
                  <StyledMenuToggle1 className="hide" collapsed={collapsed}>
                    {React.createElement(
                      collapsed
                        ? StyledMenuFoldOutlined
                        : StyledMenuUnfoldOutlined,
                      { onClick: toggleCollapse }
                    )}
                  </StyledMenuToggle1>
                  <StyledMenuToggle
                    collapsed={collapsed}
                    onClick={() => showDrawer()}
                  >
                    {collapsed ? (
                      <StyledMenuFoldOutlined />
                    ) : (
                      <StyledMenuUnfoldOutlined />
                    )}
                  </StyledMenuToggle>
                </Col>
              </Row>
            </StyleSuperHODDiv>
          )}
          {!isLoadingDataFirstTime && <DashboardTop />}
        </Col>

        <Col xs={12} sm={12} md={12} lg={8} xl={5}>
          <div className="text-center">
            {/* <img style={imgStyle} src={userlogo} alt="BDO" /> */}
          </div>
        </Col>

        <StyledCol xs={12} sm={12} md={12} lg={10} xl={10}>
          <StyledIconContainer>
            {isLoadingDataFirstTime && (
              <>
                {headerSkeleton("right-header-skeleton")}
                {headerSkeleton("right-header-skeleton")}
              </>
            )}
            {!isLoadingDataFirstTime && (
              <>
                {PayAccess && (
                  <div>
                    <FloatingButton />
                  </div>
                )}
                {showplan && (
                  <Subscription
                    className="bg-white"
                    onClick={() => setshowplan(true)}
                    showplan={showplan}
                    setshowplan={setshowplan}
                  />
                )}

                {/* ── Timer Icon + Controls (next to + New button) ── */}
                <NewButtonWrapper ref={newMenuRef}>
                  {/* Timer: IDLE → show clock icon only */}
                  {timerState === T.IDLE && (
                    <Tooltip title="Start Timer" placement="bottom">
                      <TimerIconBtn onClick={handleTimerIconClick}>
                        <TimerGreyIcon />
                      </TimerIconBtn>
                    </Tooltip>
                  )}

                  {/* Timer: RUNNING */}
                  {timerState === T.RUNNING && (
                    <>
                      <TimerBadgeInline>
                        <TimerIcon style={{ marginRight: 6 }} />
                        {formatTime(elapsed)}
                      </TimerBadgeInline>

                      <TimerCtrlBtn className="pause" onClick={handleTimerPause}>
                        <PauseOutlined style={{ background: "#f59e0b", color: "#fff" }} /> Pause
                      </TimerCtrlBtn>

                      <TimerCtrlBtn className="stop" onClick={handleTimerStop}>
                        <StopOutlined style={{ background: "#ef4444", color: "#fff" }} /> Stop
                      </TimerCtrlBtn>
                    </>
                  )}

                  {/* Timer: PAUSED */}
                  {timerState === T.PAUSED && (
                    <>
                      <TimerBadgeInline>
                        <ClockCircleOutlined style={{ marginRight: 6 }} />
                        {formatTime(elapsed)}
                      </TimerBadgeInline>

                      <TimerCtrlBtn className="play" onClick={handleTimerPlay}>
                        <CaretRightOutlined style={{ background: "#0ea5e9", color: "#fff" }} /> Play
                      </TimerCtrlBtn>

                      <TimerCtrlBtn className="stop" onClick={handleTimerStop}>
                        <StopOutlined style={{ background: "#ef4444", color: "#fff" }} /> Stop
                      </TimerCtrlBtn>
                    </>
                  )}

                  {/* + New Dropdown */}
                  <Dropdown
                    menu={{ items: dropdownItems }}
                    placement="bottomRight"
                    overlayStyle={{ minWidth: 200 }}
                  >
                    <ButtonOutlined
                      className="apply-leave-sm m-0"
                      style={{
                        minWidth: 110,
                        padding: "5px 18px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        justifyContent: "center",
                        color: "#00685F",
                        borderColor: "#00685F",
                      }}
                    >
                      <PlusOutlined style={{ fontSize: 13 }} />
                      New
                    </ButtonOutlined>
                  </Dropdown>
                </NewButtonWrapper>

                <StyledHeaderIcons>
                  {userRoleId !== "1" && (
                    <Link
                      className="mx-2"
                      to={`/my-profile`}
                      onClick={() => setPageTitle("Notification")}
                    >
                      <Tooltip placement="bottom" title={userName}>
                        {profilePic === null ||
                          Array.isArray(profilePic) ||
                          profilePic === "" ? (
                          <StyledAvatar size="default">
                            {startCase(get(userInfo, "name", "").charAt(0))}
                          </StyledAvatar>
                        ) : (
                          <StyledAvatar src={profilePic} size="default" />
                        )}
                      </Tooltip>
                    </Link>
                  )}

                  <Popover
                    placement="bottomRight"
                    content={
                      <div className="p-4">
                        <Row>
                          {Products?.map((val, index) => {
                            if (val?.access) {
                              return (
                                <Col
                                  md={8}
                                  key={index}
                                  className="items"
                                  onClick={() => {
                                    val?.url && window.open(val.url, "_self");
                                  }}
                                >
                                  <div className="logo d-flex justify-content-center align-items-center">
                                    <img
                                      width={60}
                                      height={60}
                                      src={val?.logo}
                                      alt={`${val?.name} Logo`}
                                    />
                                  </div>
                                  <p className="d-flex justify-content-center align-items-center text-center fw-medium">
                                    {val?.name}
                                  </p>
                                </Col>
                              );
                            }
                          })}
                        </Row>
                      </div>
                    }
                    trigger="click"
                    open={showSwitchApp}
                  />

                  {!userRoleId === 1 && (
                    <Link
                      className="mx-2"
                      to={`close-account`}
                      onClick={() => setPageTitle("Close Account")}
                    >
                      <Tooltip placement="bottom" title={"close account"}>
                        <SettingsIcon className="icon" />
                      </Tooltip>
                    </Link>
                  )}

                  <CustomIcon
                    className="m-2"
                    name="logout"
                    onClick={() => setShowLogoutModal(true)}
                    style={customIconStyle}
                  />
                </StyledHeaderIcons>
              </>
            )}
          </StyledIconContainer>
        </StyledCol>
      </Row>

      {/* Switch Role Modal */}
      <SwitchUserModal
        onDashboardPg={true}
        userRoleModal={userRoleModal}
        closeModal={() => setUserRoleModal(false)}
      />

      {/* Apply Leave Modal */}
      <LeaveForm
        isModalVisible={displayLeaveModal}
        leave_category_id="1"
        closeModal={() => toggleLeaveModal(false)}
        leaveDetails={{}}
      />

      {/* Time Log Modal */}
      <TimeLog
        key={timerElapsedHours}
        visible={displayTimeLogModal}
        onClose={handleTimeLogClose}
        editRecord={
          timerElapsedHours !== null
            ? { _fromTimer: true, timespenthours: timerElapsedHours }
            : undefined
        }
      />

      <ClaimsLogModal
        visible={displayClaimsLogModal}
        onClose={() => toggleClaimsLogModal(false)}
      />

      <FundRequestModal
        visible={displayFundRequestModal}
        onClose={() => toggleFundRequestModal(false)}
      />

      {/* ✅ Fixed: displayIncidentModal and toggleIncidentModal now properly defined */}
      {displayIncidentModal && (
        <ReportIncident
          isModalVisible={displayIncidentModal}
          closeModal={() => toggleIncidentModal(false)}
        />
      )}

      {/* ── AddTask modal ── */}
      <AddTask
        isModalVisible={displayTaskModal}
        closeModal={() => toggleTaskModal(false)}
        getTaskList={handleGetTaskList}
      />

      <CreateEventModal
        visible={displayEventModal}
        onClose={(shouldRefresh) => {
          toggleEventModal(false);
          if (shouldRefresh) {
            window.dispatchEvent(new CustomEvent("calendar-events-updated"));
          }
        }}
      />

      <Modal
        open={showLogoutModal}
        onCancel={() => setShowLogoutModal(false)}
        closable={false}
        footer={[
          <StyledButtonCancel
            key="cancel"
            onClick={() => setShowLogoutModal(false)}
          >
            Cancel
          </StyledButtonCancel>,
          <StyledButtonUpdate key="logout" onClick={handleLogout}>
            Logout
          </StyledButtonUpdate>,
        ]}
      >
        <p>Are you sure you want to logout?</p>
      </Modal>
    </StyledAntHeader>
  );
};

const mapStateToProps = (state) => ({
  userName: getUserName(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  departmentList: getDepartmentList(state),
  roleName: getRoleName(state),
  departmentName: getDepartmentName(state),
  isLoadingDataFirstTime: getLoadingDataFirstTime(state),
  userRoleId: getUserRoleId(state),
  roleList: getRoleList(state),
  userRoleList: getUserRoleList(state),
  notificationList: getNotificationList(state),
  userInfo: getUserInfo(state),
  profilePic: getProfilePic(state),
  allDepartmentList: getAllDepartmentList(state),
  clientId: getClientid(state),
  menuList: getMenuList(state),
  leaveCategoryList: getLeaveCategoryList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDepartmentId: setDepartmentId,
      saveNotificationList: setNotificationList,
      removeStoreData: clearStore,
      updateProcessingModal: toggleProcessingModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Header);